'use strict';

// const map = require('lodash/map');
// const mapValues = require('lodash/mapValues');
// const orderBy = require('lodash/orderBy');
// const angular = require('angular');
const isEqual = require('lodash/isEqual');

const FuseJS = require('fuse.js');

function controller($scope, $timeout, plannerService) {
    let vm = this;

    let allResults = [];
    let allFilters = null;
    let fuse = null;

    vm.loading = true;
    vm.updating = false;
    vm.errorLoading = false;

    vm.totalCount = 0;
    vm.results = [];
    vm.filters = null;
    vm.keyword = '';
    vm.date_filter = {
        from: null,
        to: null,
    };

    vm.updateDates = dateRange => {
        vm.date_filter = dateRange;
    }

    vm.init = function () {
        plannerService.getPerformances().then(response => {
            // Keep track of all the results
            allResults = response.filter(perf => perf.availability);

            // With the results, also generate filters
            allFilters = plannerService.generateFacets(response);

            // Inititalise Fuse search engine
            fuse = new FuseJS(allResults, plannerService.fuseOptions);

            // Filter by location (potentially)
            const locationFacets = plannerService.locationFacets(allFilters, false);

            if (locationFacets) {
                // applyFiltering calls updateView after
                applyFiltering(locationFacets.keyword, locationFacets.filters, false);
            } else {
                // updateView straight away
                updateView(allResults);
            }

            // Get a watcher going on keyword input & filters
            $scope.$watch(() => [vm.keyword, vm.filters, vm.date_filter], processChanges, true);

            // Get a watcher going on location search
            $scope.$watch(() => location.search, processLocation);
        }, e => {
            console.log(e);

            vm.errorLoading = true;
        }).catch( e => {
            console.log(e);

            vm.errorLoading = true;
        }).finally(function () {
            vm.loading = false;
        });
    }

    function processChanges(newVal, oldVal) {
        // Skip when loading, same values, or updating
        if (vm.loading || isEqual(newVal, oldVal) || vm.updating) {
            return false;
        }

        applyFiltering(newVal[0], newVal[1], true);
    }

    function processLocation(newVal, oldVal) {
        // Skip when loading, same values, or updating
        if (vm.loading || isEqual(newVal, oldVal) || vm.updating) {
            return false;
        }

        // Figure out what we need to filter!
        const locationFacets = plannerService.locationFacets(vm.filters, true);

        // Use that to apply our filtering
        applyFiltering(locationFacets.keyword, locationFacets.filters, false);
    }

    function applyFiltering(keyword, filters, updateLocation) {
        // Keep track is updating to prevent watch firing
        vm.updating = true;

        // Grab our items to begin with
        let filteredItems = allResults;

        // Filter by keywords first if possible
        if (keyword && keyword.length) {
            filteredItems = fuse.search(keyword);
        }

        // Now, apply filters
        const result = plannerService.applyFilters({
            filters: filters,
            items: filteredItems
        });

        result.items = result.items.filter(perf => {
            if (!vm.date_filter.start || !vm.date_filter.end) {
                return true;
            }
            return vm.date_filter.start < perf.start_date_moment && vm.date_filter.end > perf.start_date_moment;
        });

        // Update location search on first load
        if (updateLocation) {
            plannerService.updateLocation(keyword, result.facets);
        }

        vm.results = [];

        // Update view :3
        updateView(result.items, result.facets, keyword);
    }

    function updateView(items, facets, keyword) {
        // Keep track is updating to prevent watch firing
        vm.updating = true;

        // Update keyword field if there's one in URL but not in field
        if (vm.keyword !== keyword) {
            vm.keyword = keyword;
        }

        // Grab count before grouped
        vm.totalCount = items.length;

        // Expose items
        vm.results = plannerService.groupByDay(items);

        // Generate filters!
        vm.filters = plannerService.updateFilters({
            filters: vm.filters || allFilters,
            items: items,
            facets: facets || [],
            keyword: keyword
        });

        // Reset updating flag
        $timeout(function () {
            vm.updating = false;
        });
    }

    return vm;
}

module.exports = [
    '$scope',
    '$timeout',
    'plannerService',
    controller
];



// WEBPACK FOOTER //
// ./widgets/controllers/EventList.js